import crypto from "crypto";
export function decrypt(encdata) {
  try {
    const ALG = 'aes-256-gcm';
    const ENCRYPTION_KEY = "8jiue5gT05km9yJfq4lDrFoJFcaloYAW"; // base64 decoding

    const bData = Buffer.from(encdata, 'base64'); // convert data to buffers

    const salt = bData.slice(0, 64);
    const iv = bData.slice(64, 80);
    const tag = bData.slice(80, 96);
    const text = bData.slice(96); // derive key using; 32 byte key length

    const key = crypto.pbkdf2Sync(ENCRYPTION_KEY, salt, 2145, 32, 'sha512'); // AES 256 GCM Mode

    const decipher = crypto.createDecipheriv(ALG, key, iv);
    decipher.setAuthTag(tag); // encrypt the given text

    const decrypted = decipher.update(text, 'binary', 'utf8') + decipher.final('utf8');
    return decrypted;
  } catch (e) {
    console.log('ERROR DECRYPT TEXT: ', e);
  } // error


  window.localStorage.clear();
  return window.location.href = `/login`;
}
export function allowedRole(user, roles) {
  const userData = decryptSession(user);
  return userData && userData.role ? roles.includes(userData.role) : false;
}
export function decryptSession(userSession) {
  if (userSession) {
    if (typeof userSession.session === "string") {
      return JSON.parse(decrypt(userSession.session));
    }
  }

  return undefined;
}
export function checkRoles(user, roles) {
  return user && user.role ? roles.includes(user.role) : false;
}